<dl>
  <dt><strong>{{title}}</strong></dt>

  <dd *ngFor="let object of socialCollection">
    <a target="{{object.target}}" href="{{object.href}}">{{object.name}}</a>
  </dd>
</dl>
